import { Subscript } from './index';
import { markInputRule, markPasteRule } from '@tiptap/core';

const inputRegex = /(?:^|\s)((?:,,)((?:[^,]+))(?:,,))$/;
const pasteRegex = /(?:^|\s)((?:,,)((?:[^,]+))(?:,,))/g;

export const CustomSubscript = Subscript.extend({
   addInputRules() {
      return [
         markInputRule({
            find: inputRegex,
            type: this.type,
         }),
      ];
   },

   addPasteRules() {
      return [
         markPasteRule({
            find: pasteRegex,
            type: this.type,
         }),
      ];
   },
});
